// In your action.js or /store/modules/utils.js

import { get } from '@/services/api';

export default {
  async getMotivationalImageUrl(context) {`Ï`
    console.log('✅ getMotivationalImageUrl() triggered');
    try {
      console.log('Calling GET /utils/get-motivational-image-url...');
      const response = await get('/utils/get-motivational-image-url');
      console.log('✅ API Response:', response.data);
      return response.data; 

    } catch (error) {
      console.error('❌ API error in getMotivationalImageUrl:', error);
      throw error; // Propagate the error
    }
  }
};